<template >
  <div style="">
    <div  >

      <div style="top:-156px;position:fixed;">
        <div style="z-index:0;position:relative;width:100%;height:calc(100vh + 200px);margin-left:0;background: rgb(154,255,186);background: linear-gradient(40deg, rgb(255 255 255 / 72%) 0%, rgb(2 4 4) 100%);">
          <video  loop="" muted="" autoplay=""  style="opacity: 0.2;pointer-events: none;z-index: -1;height:calc(100vh + 200px);">">
            <source :src="require('../assets/white_flare.webm')" type="video/webm">
          </video>
        </div>
      </div>
      <v-row style="width:100%;height:100%;margin-top:200px;">

        <v-col style="display:inline-flex;" cols="12" align="center" justify="center" >
          <v-spacer></v-spacer>
          <v-card tile style="height: 368px; width: 271px; margin-right: -16px; margin-top: 242px; background: rgb(238, 238, 238);">
            <v-card-text style="padding:40px;text-align: right;">

              <v-chip color="transparent" label style="margin-top:6px;margin-bottom:6px;">Swish-donationer</v-chip><br>
              <v-divider></v-divider>
              <v-chip color="transparent" style="margin-top:6px;margin-bottom:6px;" label >Alerts</v-chip><br>
              <v-divider></v-divider>
              <v-chip color="transparent"  style="margin-top:6px;margin-bottom:6px;" label >Största donation</v-chip><br>
              <v-divider></v-divider>
              <v-chip color="transparent"  style="margin-top:6px;margin-bottom:6px;" label >Hihat-sida</v-chip><br>
              <v-divider></v-divider>
              <v-chip color="transparent"   style="margin-top:6px;margin-bottom:6px;" label> Anonymt</v-chip><br>
              <v-divider></v-divider>
              <v-chip color="transparent"   style="margin-top:6px;margin-bottom:6px;" label >Skattat</v-chip><br>
              <v-divider></v-divider>
              <v-chip color="transparent"   style="margin-top:6px;margin-bottom:6px;" label >Transaktionsavgift</v-chip><br>


            </v-card-text>
          </v-card>

          <v-card tile style="height:680px;width:400px;margin:10px;">
            <v-card-text style="background:#bbbbbb;color:white;">
              <v-row style="width:100%;height:200px;" align="center" justify="center">
                <v-col style="" cols="12" align="center" justify="center"><h1 class="" style="font-family: 'Righteous', cursive;font-size:40px;">Hihat <span style="font-family:'Roboto'">Basic</span></h1><br><h1>0 kr/månad</h1></v-col>

              </v-row>
            </v-card-text>
            <v-card-text style="padding:40px;text-align: center;">

              <v-chip color="#3bd0a5" label dark style="margin-top:6px;margin-bottom:6px;">Ja</v-chip><br>
              <v-divider></v-divider>
              <v-chip color="#3bd0a5" style="margin-top:6px;margin-bottom:6px;" label dark>Ja</v-chip><br>
              <v-divider></v-divider>
              <v-chip color="gray"  style="margin-top:6px;margin-bottom:6px;" label dark>500 kr</v-chip><br>
              <v-divider></v-divider>
              <v-chip color="gray"  style="margin-top:6px;margin-bottom:6px;" label dark>Basic</v-chip><br>
              <v-divider></v-divider>
              <v-chip color="gray"  style="margin-top:6px;margin-bottom:6px;" label dark>Nej</v-chip><br>
              <v-divider></v-divider>
              <v-chip color="gray"  style="margin-top:6px;margin-bottom:6px;" label dark>Nej</v-chip><br>
              <v-divider></v-divider>
              <v-chip color="gray"  style="margin-top:6px;margin-bottom:6px;" label dark>5% + 5kr</v-chip><br>


            </v-card-text>
            <v-card-actions>
              <v-btn
                block
                dark
              >Välj Basic</v-btn>
            </v-card-actions>

          </v-card>



          <v-card tile style="height:680px;width:400px;margin:10px;">
            <v-card-text style="background: linear-gradient(40deg, rgba(164, 65, 248, 0.72) 0%, rgb(47, 218, 158) 100%);color:white;">
              <v-row style="width:100%;height:200px;" align="center" justify="center">
                <v-col style="" cols="12" align="center" justify="center"><h1 class="" style="font-family: 'Righteous', cursive;font-size:40px;margin-top: 54px;">Hihat <span style="font-family:'Roboto'">Pro</span></h1>
                  <br><h1>69 kr/månad</h1>
                  <br><h3>i genomsnitt <v-chip dark color="#3bd0a5">2X</v-chip> större donationer*</h3>
                  <small style="">*Jämfört med Hihat Basic-användare i perioden Mars 2022</small>


                </v-col>

              </v-row>
            </v-card-text>
            <v-card-text style="padding:40px;text-align: center;">

              <v-chip color="#3bd0a5" label dark style="margin-top:6px;margin-bottom:6px;">Ja</v-chip><br>
              <v-divider></v-divider>
              <v-chip color="#3bd0a5" style="margin-top:6px;margin-bottom:6px;" label dark>Ja</v-chip><br>
              <v-divider></v-divider>
              <v-chip color="#3bd0a5"  style="margin-top:6px;margin-bottom:6px;" label dark>150 000 kr</v-chip><br>
              <v-divider></v-divider>
              <v-chip color="#3bd0a5"  style="margin-top:6px;margin-bottom:6px;" label dark>Custom</v-chip><br>
              <v-divider></v-divider>
              <v-chip color="#3bd0a5"  style="margin-top:6px;margin-bottom:6px;" label dark>Valfritt</v-chip><br>
              <v-divider></v-divider>
              <v-chip color="#3bd0a5"  style="margin-top:6px;margin-bottom:6px;" label dark>Valfritt</v-chip><br>
              <v-divider></v-divider>
              <v-chip color="#3bd0a5"  style="margin-top:6px;margin-bottom:6px;" label dark>3,25% + 2,95kr</v-chip><br>


            </v-card-text>
            <v-card-actions>
              <v-btn
                  block
                  dark
                  color="#3bd0a5"
              >Prova 1 månad GRATIS</v-btn>
            </v-card-actions>

          </v-card>
          <v-spacer></v-spacer>


        </v-col>
      </v-row>




    </div>


  </div>
</template>

<script>
export default {
  name: 'Pro',
  components: {

  },
  data(){
    return {
      tab:0
    }

  },
  computed:{

    minHeight () {
      const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

      return `calc(${height} - ${this.$vuetify.application.top}px)`
    },
    query () {
      return this.$route.query
    }
  },
  methods:{
    letsgo:function(){
      this.$store.state.APP.SHOW_LOGIN=true;
    },



  },
  watch:{
    tab: function (newVal) {
      if(newVal===0){
        window.history.replaceState(null, null, window.location.pathname);
      }
      else{
        window.history.replaceState(null, null, window.location.pathname+"?k=ek");

      }
    },
    query:function(newVal){
      if(Object.prototype.hasOwnProperty.call(newVal, "k")){

        this.tab=1;
      }
      else{
        this.tab=0;
      }

    }
  },
  mounted:function(){
    document.title="Hihat";
    if(this.$route.query.k==="ek"){
      this.tab=1;
    }


  }

}
</script>

<style scoped>
.lift_me_up> * img{
  top:-200px;
}

@keyframes spin {
  from {
    transform:rotate(0deg);
  }
  to {
    transform:rotate(360deg);
  }
}

.spin_da_guthen{
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  /* transform: rotate(3deg); */
  /* transform: rotate(0.3rad);/ */
  /* transform: rotate(3grad); */
  /* transform: rotate(.03turn);  */
}

.theme--dark.v-data-table tbody tr:hover{
  background: rgba(255,255,255,0.1) !important;
}
</style>
